export default {
  state: {
    targetName: '',
    properties: [],
  },
  getters: {
    targetName: (state: any) => {
      return state.targetName;
    },
    properties: (state: any) => {
      return state.properties;
    },
    selectedProperty: (state: any) => {
      const properties = state.properties;
      const targetName = state.targetName ? state.targetName : sessionStorage.getItem('selectedTargetName');
      if (state.targetName) {
        sessionStorage.setItem('selectedTargetName', state.targetName);
      }
      const selectedProperty = properties.find((p: any) => p.targetName === targetName);
      return selectedProperty || properties[0] || {};
    },
  },
  mutations: {
    updateTargetName: (state: any, value: any) => {
      state.targetName = value || '';
    },
    updateProperties: (state: any, value: any) => {
      state.properties = value || [];
    },
  },
};
